import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// 🎨 Icons couleurs
const createCustomIcon = (color: string) =>
  new L.DivIcon({
    className: 'custom-marker',
    html: `
      <div style="
        background:${color};
        width:20px;
        height:20px;
        border-radius:50%;
        border:3px solid white;
        box-shadow:0 0 5px rgba(0,0,0,0.5);
      "></div>
    `,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

type Appointment = {
  id: string | number;
  lat: number;
  lng: number;
  status: 'done' | 'pending' | 'cancel' | 'urgent';
  client: string;
};

type Props = {
  appointments: Appointment[];
};

function FitBounds({ points }: { points: { lat: number; lng: number }[] }) {
  const map = useMap();

  useEffect(() => {
    if (!points.length) return;

    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));

    map.fitBounds(bounds, {
      padding: [50, 50], // espace autour
    });
  }, [points, map]);

  return null;
}

const MapCluster = ({ appointments }: Props) => {
  const coords = appointments.filter((c: any) => c.coord?.lat && c.coord?.lng);

  return (
    <MapContainer
      center={[48.8566, 2.3522]}
      zoom={12}
      minZoom={5}
      maxZoom={18}
      style={{ height: '100%', width: '100%' }}
    >
      {/* <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' /> */}
      <TileLayer url='https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' />
      <FitBounds points={coords.map((a: any) => a.coord)} />

      <MarkerClusterGroup>
        {coords.map((rdv: any) =>
          !rdv.coord ? null : (
            <Marker
              key={rdv._id}
              position={[rdv.coord.lat, rdv.coord.lng]}
              icon={createCustomIcon(rdv.user?.userColor || 'lightgray')}
            >
              <Popup>
                <strong>
                  {rdv.user?.name || rdv.user?.login || 'Non assigné'}
                </strong>
                <br />
                Adresse: {rdv.destinationAddress}
              </Popup>
            </Marker>
          ),
        )}
      </MarkerClusterGroup>
    </MapContainer>
  );
};

export default MapCluster;
